<template>
    <h1 class="text-base lg:text-lg font-bold mb-3">
        <slot />
    </h1>
</template>